export const HAS_SIGNED_OUT = 'reset-timeout-has-timed-out';
